<template>

    <div>

        <skoly-menu
            @updateProfil="emitUpdateProfil"
            :profil="profil"
        />

        <main class="profileDashboard">

            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <h2>Zoznam z logov</h2>
                        <div class="bg-white pl-30 pt-30 pr-30 pb-30 mb-30 rounded-10">
                            <table class="mb-0 log-list">
                                <tr class="log d-flex align-items-center" v-for="(log, index) in logyBodov" :key="index">
                                    <td width="150">{{ log.created_at | moment('D.M.YYYY') }} {{ log.created_at | moment('HH:mm') }}</td>
                                    <td width="40" align="left">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="8" height="50" viewBox="0 0 8 50">
                                            <g id="Group_9" data-name="Group 9" transform="translate(-21)">
                                                <line id="Line_1" data-name="Line 1" y2="50" transform="translate(25)" fill="none" stroke="rgba(0,0,0,0.1)" stroke-width="1"/>
                                                <g id="Ellipse_1" data-name="Ellipse 1" transform="translate(21 21)" fill="#e5e5e5" stroke="#e5e5e5" stroke-width="1">
                                                <circle cx="4" cy="4" r="4" stroke="none"/>
                                                <circle cx="4" cy="4" r="3.5" fill="none"/>
                                                </g>
                                            </g>
                                        </svg>
                                    </td>
                                    <td class="mb-0">Aktivita:
                                        <template v-if="log.cinnost === 'stastie-kravicky'"><b class="text-dark">Šťastie kravičky</b></template>
                                        <template v-else-if="log.cinnost === 'kvizova-uloha'"><b class="text-dark">Kvízová úloha</b></template>
                                        <template v-else><b class="text-dark">{{log.cinnost}}</b></template>; získaný počet bodov <b class="text-success">+{{ log.skolske_body_zmena }}</b>; nový bodový stav = <b class="text-primary">{{ log.skolske_body_po }}</b>
                                    </td>
                                    <!-- {{log}} -->
                                </tr>
                            </table>
                        </div>

                        <a href="#" class="btn --primary" v-if="paginateCursor" @click="loadLogData">Zobraziť viac</a>

                    </div>
                </div>
            </div>

        </main>

    </div>
</template>

<script>
import SkolyMenu from "@/components/skoly/SkolyMenu.vue";
import EventService from "@/services/EventService";

export default {
    components: {
        SkolyMenu,
    },
    props: [
        'profil',
    ],
    data() {
        return {
            logyBodov: [],
            paginateCursor: ''
        }
    },
    mounted() {
        this.loadLogData()
    },
    methods: {
        // emit
        emitUpdateProfil() {
            this.$emit('updateProfil')
        },

        async loadLogData() {
            let { data } =  await EventService.getLogBodov(this.paginateCursor)
            this.logyBodov = [ ...this.logyBodov, ...data.logy.data ]

            if ( data.logy.next_page_url ){
                const params = new URL(data.logy.next_page_url).searchParams;
                this.paginateCursor = params.get('cursor');
            } else {
                this.paginateCursor = ''
            }
        },
    }
}
</script>
